import SkatteverketSvg from "@bokio/assets/images/skatteverket.svg";
import { Paragraph } from "@bokio/designsystem/components/TypographicElements/TypographicElements";

import type * as m from "@bokio/mobile-web-shared/core/model/model";
import type { FC } from "react";

import * as styles from "./bankLogo.scss";

interface BankLogoProps {
	bank: m.Bokio.Bank.Contract.Dtos.BankForView;
	testId?: string;
	hideName?: boolean;
	size?: "small" | "big";
}

export const BankLogo: FC<BankLogoProps> = ({ bank, testId, size, hideName }) => {
	const height = size === "big" ? 40 : 20;
	const width = size === "big" ? 40 : 20;

	return (
		<span className={styles.container}>
			<img
				src={bank.LogoPath === "SkatteverketSvg" ? SkatteverketSvg : `${bank.LogoPath}?width=${width}&height=${height}`}
				className={styles.logoImg}
				data-testid={testId}
				width={width}
				height={height}
			/>
			{bank.Name && !hideName && (
				<span className={styles.bankName}>
					<Paragraph style={size === "big" ? "heading-default" : "body-bold"}>{bank.Name}</Paragraph>
				</span>
			)}
		</span>
	);
};
